module.exports = __webpack_public_path__ + "img/text_personal_center.b1e8894b.png";